import { Stack } from "@mui/material";
import React, { useState } from "react";
import RHFErrorMessage from "./RHFErrorMessage";
import MUIRichTextEditor from "mui-rte";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Controller } from "react-hook-form";
import { EditorState, convertToRaw } from "draft-js";
import RichContentViewer from "./RichContentViewer";

export const editorTheme = createTheme({
  overrides: {
    MuiIconButton: {
      root: { color: "#555" },
    },
    MUIRichTextEditor: {
      root: {
        border: "1px solid #ccc",
        borderRadius: 8,
        overflow: "hidden",
        "&:focus-within": { borderColor: "#1b5e20" },
      },
      toolbar: {
        borderBottom: "1px solid #e0e0e0",
        backgroundColor: "#fafafa",
        padding: "2px 4px",
      },
      editor: {
        minHeight: 80,
        padding: "8px 14px",
        fontSize: "0.9rem",
        lineHeight: 1.6,
        overflow: "auto",
      },
      placeHolder: {
        padding: "8px 14px",
        width: "inherit",
        position: "static",
        color: "#9e9e9e",
        fontSize: "0.9rem",
      },
      anchorLink: { color: "#1565c0", textDecoration: "underline" },
    },
  },
});

export const RHFRichEditor = ({ view, content, ...props }) => {
  const [richContent, setRichContent] = useState();

  if (view) {
    return <RichContentViewer content={content} />;
  }

  const { register, errors, name, control, label, required, value } = props;
  if (register) register(name, { required, value });

  return (
    <Stack>
      <ThemeProvider theme={editorTheme}>
        <Controller
          name={name}
          control={control}
          rules={{ required: required || false }}
          render={({ field: { value, onChange, ...field } }) => (
            <MUIRichTextEditor
              label={label}
              defaultValue={value}
              onBlur={() => onChange(richContent)}
              onChange={(e) => {
                const currentState = e.getCurrentContent();
                if (currentState.hasText()) {
                  const rteContent = convertToRaw(currentState);
                  rteContent && setRichContent(JSON.stringify(rteContent));
                }
              }}
              inlineToolbar={true}
              controls={[
                "bold", "italic", "underline", "strikethrough",
                "highlight", "link", "numberList", "bulletList",
                "quote", "code",
              ]}
            />
          )}
        />
      </ThemeProvider>
      {errors && <RHFErrorMessage errors={errors} name={name} />}
    </Stack>
  );
};
